import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/villageScratchAndWin',
        name: 'villageScratchAndWin',
        meta: { sideMenuLabel: "Gratta e vinci" },
        component: () => import("./views/villageScratchAndWin.vue")
    },
    {
        path: '/villageScratchAndWin/:identifier',
        name: 'villageScratchAndWinDetail',
        component: () => import("./views/villageScratchAndWinDetail.vue")
    },
    {
        path: '/villageScratchAndWinPlays',
        name: 'villageScratchAndWinPlays',
        meta: { sideMenuLabel: "Giocate" },
        component: () => import("./views/villageScratchAndWinPlays.vue")
    },
];

export default routes;